import { captureException } from '@sentry/node';
import { getErrorMessage } from '@r1-frontend/do-request/error/baseErrorBody';
import { isAxiosError } from '@r1-frontend/do-request/guards/isAxiosError';
import { isAxiosTimeoutError } from '@r1-frontend/do-request/guards/isAxiosTimeoutError';
import { isResponseCanceled } from '@r1-frontend/shared/helpers/isResponseCanceled';
import { EHttpStatusCode } from '@r1-frontend/shared/types/EHttpStatusCode';
var UNKNOWN_ERROR_ERROR_CODE = 'UNKNOWN_ERROR';
export var UNKNOWN_ERROR = {
    code: UNKNOWN_ERROR_ERROR_CODE,
    message: 'Неизвестная ошибка',
};
var excludeHttpCodes = [EHttpStatusCode.NOT_FOUND, EHttpStatusCode.UNAUTHORIZED];
/**
 * Отправляет информацию об ошибке в сентри
 * @param e
 */
var sendToSentry = function (e) {
    var _a, _b, _c;
    var isSsr = typeof window === 'undefined';
    if (isAxiosError(e)) {
        // Ошибки с кодами, которые не отправляем в Сентри
        if (e.response && excludeHttpCodes.includes((_a = e.response) === null || _a === void 0 ? void 0 : _a.status)) {
            return;
        }
        // Если запрос отменен не отправляем в Сентри
        if (isResponseCanceled(e.message)) {
            return;
        }
        var _d = e.config, baseURL = _d.baseURL, url = _d.url, timeout = _d.timeout;
        var message = (_c = (_b = e.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message;
        captureException(e, {
            extra: {
                message: message,
                baseURL: baseURL,
                url: url,
                timeout: timeout,
            },
            tags: {
                place: 'api-query',
                'api-url': baseURL,
                isSsr: isSsr,
            },
        });
    }
    else {
        captureException(e, {
            tags: {
                place: 'api-query (not axios error)',
                isSsr: isSsr,
            },
        });
    }
};
/**
 * Парсит сообщение об ошибке
 * @param e - error object
 */
export var captureQueryError = function (e) {
    var _a;
    sendToSentry(e);
    if (isAxiosTimeoutError(e)) {
        return {
            isSuccess: false,
            error: {
                code: e.name,
                message: e.message,
            },
        };
    }
    if (isAxiosError(e) && ((_a = e.response) === null || _a === void 0 ? void 0 : _a.data)) {
        var _b = e.response, data = _b.data, status_1 = _b.status;
        return {
            isSuccess: false,
            error: {
                code: data.code || data.status || UNKNOWN_ERROR.code,
                message: data.message || 'Не содержит message',
                status: Number(status_1),
            },
        };
    }
    return {
        isSuccess: false,
        error: {
            code: UNKNOWN_ERROR.code,
            message: getErrorMessage(e) || UNKNOWN_ERROR.message,
            data: e,
        },
    };
};
